define('components/factory/views/MultiProductsView', [
    'components/factory/templates/multiproductsview',
    'components/ecrinbridge/EcrinBridge',
    'components/trackingbridge/TrackingBridge'
], function(tpl, EcrinBridge, TrackingBridge) {

    return Mazarine.View.extend({

        events: {
            "click .js-maz-multiproducts-checkbox": "onSelectProduct",
            "click .js-maz-multiproduct-order-btn": "onClickAddToCart",
            "click .js-maz-multiproducts-more-btn": "onClickShowMore",
            "change .js-maz-multiproducts-retailer": "onRetailerChange",
            "click .js-maz-multiproducts-btn-retailer": "onClickBtnRetailer"
        },

        template: tpl,

        className: "maz-multiproducts-view",

        productModel: [],
        productView: [],
        productsSelected: [],
        productsReady: 0,

        initialize: function(options) {
            Mazarine.View.prototype.initialize.call(this);

            this.Factory = options.factory;
            this.productsSelected = [];
            this.productModel = [];
            this.productView = [];
        },

        getRenderDatas: function() {
            var obj = this.model.toJSON();
            if( this.model.get('products').length % 2 === 1 ){
                obj.gridOddClass = true;
            }

            obj.quantities = this.getQuantities();
            obj.skus = this.getSkus();
            obj.codeys = this.getCodeYs();

            return obj;
        },

        /*
         * Create all the products and wait for them to be ready
         */
        afterRender: function() {
            _.each( this.model.get("products"), _.bind(function( item, index ) {
                var obj = _.extend( {
                    "type": "productview",
                    "viewId": _.uniqueId( "multiproducts-product-view-" + item.codeY + "-" )
                }, item);

                this.productModel[index] = this.Factory.createModelFromData(obj);
                this.productView[index] = this.Factory.createViewFromModel(this.productModel[index]);
                this.productsSelected[index] = false;

                this.listenTo( this.productModel[index], "change:isReady", _.bind( this.onProductReady, this ) );
                this.listenTo( this.productModel[index], "change:currentSku", _.bind( this.updateOrderDatas, this ) );
                if (this.model.get('suffixClass') === "grid") {
                    this.listenTo( this.productModel[index], "change:swatchOpened", _.bind( this.dispatchSwatchPopinState, this ) );
                }

                this.$('.maz-multiproducts-product').eq(index).prepend( this.productView[index].render().$el );
                if( this.productView[index].afterRender ){
                    this.productView[index].afterRender();
                }

            }, this));

            this.createCustomSelect();
            this.checkboxPolyfill();
        },

        checkboxPolyfill: function () {
            // TODO Put this in a helper ?
            // IE7 :before, :after FIX
            if ($('html').hasClass('lt-ie8') || $('html').hasClass('lte8')) {
                this.$('.maz-multiproducts-checkbox + label').each(function() {
                    $('<span class="before"></span>').prependTo($(this));
                });
            }

            // IE7-8 :checked FIX
            if ($('html').hasClass('lt-ie9') || $('html').hasClass('lte9')) {
                this.$('.maz-multiproducts-checkbox:checked').each(function() {
                    $(this).addClass('checked');
                });
                this.$('.maz-multiproducts-checkbox').on('click', function() {
                    $(this).toggleClass('checked');
                });
            }
        },

        createCustomSelect: function() {
            this.$('.maz-select-custom').mazCustomSelect({prefix: "maz", fixwidth: true}); //TODO peut être config différente pour les filtres
        },

        /*
         * Return the currency used in the view (the one of the first productModel)
         */
        getCurrency: function( symbol ) {
            var tmp = _.uniq( _.compact( _.invoke( this.productModel, 'getCurrency' ) ) );
            var currency = this.productModel[0] && tmp.length > 0 ? tmp[0] : null;
            if (symbol && currency) {
                var currencySymbol = this.model.get("currencySymbol");
                if (currencySymbol && currencySymbol[currency]) {
                    currency = currencySymbol[currency];
                }
            }

            return currency;
        },

        getProductPrice: function( index ) {
            return this.productModel[index].getPrice();
        },

        /*
         * Return total price of selected products
         */
        getTotalPrice: function() {
            var total = 0;
            _.each( this.productModel, _.bind(function( item, index ) {
                if( this.productsSelected[index] ){
                    total += parseFloat( this.productModel[index].getPrice() );
                }
            }, this));

            return total.toFixed(2);
        },

        /*
         * Return total price of selected products with the currency
         */
        getTotalPriceFormated: function() {
            var formatHelper = this.model.get('formatHelper'),
                total = this.getTotalPrice();

            if( formatHelper ) {
                total = formatHelper.formatCurrency( this.getCurrency(), total );
            }

            return total;
        },

        /*
         * Return the number of product selected
         */
        getTotalProductSelected: function() {
            var count = 0;
            _.each( this.productsSelected, _.bind(function( item, index ) {
                if( this.productsSelected[index] ){
                    count++;
                }
             }, this));
            return count;
        },

        /*
         * Return the quantity of each selected product separated by commas
         */
        getQuantities: function() {
            var quantities = [];

            _.each( this.productsSelected, _.bind(function( item, index ) {
                if( this.productsSelected[index] ){
                    quantities.push(this.productModel[index].get('quantity'));
                }
             }, this));

            return quantities.join(',');
        },

        /*
         * Return codeY of each selected product separated by commas
         */
        getCodeYs: function() {
            var codeys = [];

            _.each( this.productsSelected, _.bind(function( item, index ) {
                if( this.productsSelected[index] ){
                    codeys.push(this.productModel[index].get('codeY'));
                }
             }, this));

            return codeys.join(',');
        },

        /*
         * Return sku of each selected product separated by commas
         */
        getSkus: function() {
            var skus = [];

            _.each( this.productsSelected, _.bind(function( item, index ) {
                if( this.productsSelected[index] ){
                    skus.push(this.productModel[index].get('currentSku'));
                }
             }, this));

            return skus.join(',');
        },

        /*
         * Call every time a product is ready
         */
        onProductReady: function( model, ready ) {
            this.productsReady++;

            if( model && model.get('error') ) {
                _.filter( this.productView, function( v ) { return v.model.cid === model.cid; } )[0].$el.parents('.maz-multiproducts-item').addClass('maz-multiproducts-error');
            }

            _.each( this.model.get("products"), function( item, index ) {
                if (this.productModel[index].cid === model.cid) {
                    var currentSkuInfo = model.getCurrentSkuInfo();
                    if( model.get('error') !== null) {
                        this.$('.maz-multiproducts-choice').eq(index).hide();
                        this.$('.js-maz-multiproducts-checkbox').eq(index).attr('disabled', "disabled");
                    }
                    if (model.get('hasUnavailableLayer') && currentSkuInfo.availability && currentSkuInfo.availability.outOfStock) {
                        this.$('.js-maz-multiproducts-checkbox').eq(index).attr('disabled', "disabled");
                    }
                    if( this.model.get('autoselectHiddenProducts') ) {
                        this.$('.js-maz-multiproducts-checkbox').eq(index).trigger('click');
                    } else if( !item.isHidden ) {
                        this.$('.js-maz-multiproducts-checkbox').eq(index).trigger('click');
                    }
                }
            }, this);

            if( this.productsReady === this.model.get("products").length ){
                if( !this.model.get('formatHelper') ) {
                    this.$('.maz-multiproducts-currency').html( this.getCurrency(true) );
                }

                this.model.set("isReady", true);

                // add Tracking
                var trackingOpenMultiSku = [];

                _.each( this.productModel, _.bind( function( product, index ) {
                    if( this.productsSelected[index] ){
                        trackingOpenMultiSku.push( product.getCurrentSkuInfo().hoverTrackObject.ecommerce.impressions[0] );
                    }
                }, this) );

                TrackingBridge.trackObj({
                    event: 'productClick',
                    ecommerce: {
                        click: {
                            actionField: { list: '$list' },
                            products: trackingOpenMultiSku
                        }
                    }
                }, "trackingOpenMultiSkuObj");

                TrackingBridge.trackEvent('openMultiSku');

                TrackingBridge.trackObj({
                    event: 'virtualDetail',
                    ecommerce: {
                        detail: {
                            products: trackingOpenMultiSku
                        }
                    }
                }, "trackingOpenMultiSkuVirtualDetailObj");

                TrackingBridge.trackEvent('openMultiSkuVirtualDetail');
            }
        },

        dispatchSwatchPopinState: function(model, swatchOpened) {
            _.each( this.model.get("products"), function( item, index ) {
                if (this.productModel[index].cid !== model.cid) {
                    this.productView[index].closePopinSwatch();
                    this.$('.maz-multiproducts-choice').eq(index).css('display', "block");
                } else {
                    this.$('.maz-multiproducts-choice').eq(index).css('display', ((swatchOpened) ? "none" : "block"));
                }
            }, this);
        },

        /*
         * Update datas when order change
         */
        updateOrderDatas: function() {
            // Update total price
            this.$('.maz-multiproducts-total-price').html( this.getTotalPriceFormated() );
            this.$('.maz-multiproducts-total-products').html( this.getTotalProductSelected() );

            // Update data-skus & data-quantities (used by ecrin_HE for buying)
            this.$('.maz-multiproduct-order-btn').attr('data-codeys', this.getCodeYs());
            this.$('.maz-multiproduct-order-btn').attr('data-skus', this.getSkus());
            this.$('.maz-multiproduct-order-btn').attr('data-quantities', this.getQuantities());
        },

        onSelectProduct: function( e ) {
            var productIndex = $( e.currentTarget ).parent().parent().index();
            this.productsSelected[ productIndex ] = !this.productsSelected[ productIndex ];

            this.updateOrderDatas();
        },

        onClickAddToCart: function( e ) {
            e.preventDefault();

            if( this.getTotalProductSelected() !== 0 ) {
                // EcrinBridge.addMultipleItemToCart(e, this.model.get('onAddToCartCallback'));

                var trackingAddToCart = [],
                    currencyCode = null;

                _.each( this.productModel, _.bind( function( product, index ) {
                    if( this.productsSelected[index] ){
                        trackingAddToCart.push( product.getCurrentSkuInfo().clickTrackObject.ecommerce.add.products[0] );
                        currencyCode = product.getCurrentSkuInfo().clickTrackObject.ecommerce.add.event;
                    }
                }, this) );

                TrackingBridge.trackObj({
                    event: 'addToCart',
                    addToCartType: 'Quick Buy Multi SKU',
                    ecommerce: {
                        currencyCode: currencyCode,
                        add: {
                            products: trackingAddToCart
                        }
                    }
                }, "trackingclicktrackobj");

                TrackingBridge.trackEvent('addtocartmultiple');

                _.each( this.productModel, _.bind( function( product, index ) {
                    if( this.productsSelected[index] ){
                        TrackingBridge.trackEvent('addtocart', {"{{codey}}": product.get('codeY'), "{{skucode}}": product.get('currentSku')});
                    }
                }, this) );
            }
        },

        onClickShowMore: function(e) {
            if( !this.model.get('autoselectHiddenProducts') ) {
                this.$('.maz-multiproducts-item-hidden .js-maz-multiproducts-checkbox').trigger('click');
            }
            this.$('.maz-multiproducts-item-hidden').removeClass('maz-multiproducts-item-hidden');
            this.$('.maz-multiproducts-more-btn').css('display', "none");
        },

        onRetailerChange: function(e) {
            var link = $( e.currentTarget ).val();
            this.$('.js-maz-multiproducts-btn-retailer').attr('href', link).css('visibility', (link ? "visible" : "hidden"));
        },

        onClickBtnRetailer: function( e ) {
            TrackingBridge.trackEvent('trackingretailer', { "{{retailerurl}}": this.$('.js-maz-multiproducts-btn-retailer').attr("href") });
        }
    });
});
